import { Injectable } from '@angular/core';
import { HttpService } from '../../shared/services/http/http-client.service';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';

const API_LOGIN = environment.url_login;

@Injectable({
  providedIn: 'root'
})
export class AlterarSenhaService {

  constructor(
    private httpService: HttpService,
    private httpClient: HttpClient
  ) { }

  changePassword(data: any, successHandle: Function, errorHandle: Function) {
    return this.httpService.doPost('/auth/changePassword', data, successHandle, errorHandle)
  }

  getUserData(data: any) {
    return this.httpClient.get(API_LOGIN + '/auth/userData', {
      params: {
        login: data.login,
        dominio: data.dominio
      }
    })
  }
}
